import { baseUrlImg } from "./http";
import { ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const getImageUrl = (endpoint: string, type: string) => {
  return `${baseUrlImg}/${type}/${endpoint}`;
};

export class Meta_Info {
  title =
    "Laboratory Testing Instruments & Equipments Manufacturer - Presto Group";
  description =
    "PRESTO, India's premier manufacturer, supplier & exporter of high quality Laboratory Testing Instruments, Equipments and Machines across the India.";
  keywords =
    "testing instruments, testing equipments, laboratory testing instruments manufacturer, laboratory testing equipment manufacturer, testing instruments supplier";
  slug = "https://www.prestoinstruments.com/";
  author = "Presto Technology";
  images = ["https://www.prestogroup.com/prestogroup-white-logo.jpg"];

  constructor(
    title: string,
    slug: string,
    description: string,
    keywords: string,
    author: string,
    images?: string[]
  ) {
    this.title = title;
    this.slug += `${slug}`;
    this.description = description;
    this.keywords = keywords;
    this.author = author;
    this.images = images?.length
      ? images
      : ["https://www.prestoinstruments.com/logo.svg"];
  }
  generate = () => {
    let meta = {
      title: this.title,
      description: this.description,
      keywords: this.keywords,
      author: this.author,
      alternates: {
        canonical: this.slug,
        languages: {
          "en-US": "/en-US",
        },
      },
      openGraph: {
        title: this.title,
        description: this.description,
        url: this.slug,
        siteName: "ZeaCloud",
        images: this.images,
        locale: "en_US",
        type: "website",
        author: this.author,
      },
      twitter: {
        title: this.title,
        description: this.description,
        images: this.images,
        author: this.author,
      },
    };
    return meta;
  };
}
